import { createClient } from '@supabase/supabase-js'

// Add debug logging
console.log('🔍 Environment Variables Check:')
console.log('SUPABASE_URL:', process.env.REACT_APP_SUPABASE_URL)
console.log('SUPABASE_KEY exists:', !!process.env.REACT_APP_SUPABASE_ANON_KEY)

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY

// ⚠️ Temporary fallback for testing (REMOVE IN PRODUCTION!)
const SUPABASE_URL_FALLBACK = 'https://ylymsqdwpobhvpzfvtsi.supabase.co' // e.g., https://abc123.supabase.co
const SUPABASE_KEY_FALLBACK = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InlseW1zcWR3cG9iaHZwemZ2dHNpIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTgyOTA0NDUsImV4cCI6MjA3Mzg2NjQ0NX0.lZnof0799LFzvnrGSeCMmeTMuieZRb0U_CjO1ynBqbI'

const finalUrl = supabaseUrl || SUPABASE_URL_FALLBACK
const finalKey = supabaseAnonKey || SUPABASE_KEY_FALLBACK

if (!supabaseUrl || !supabaseAnonKey) {
  console.error('⚠️ Environment variables missing! Using fallback values.')
  console.log('This means your build process is not injecting env vars properly.')
}

export const supabase = createClient(finalUrl, finalKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    storage: window.localStorage,
    storageKey: 'sb-auth-token'
  }
})

console.log('✅ Supabase client initialized with URL:', finalUrl)
